import { useMemo } from 'react';
import useAccountSpotBalances from 'src/hooks/useAccountBankBalances';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';

interface UseBalanceAssetSymbolsByQuoteValueDescParams {
	/**
	 * If true, only USDC collateral will be returned.
	 * If false or undefined, all collateral with balance > 0 will be returned.
	 */
	isIsolated?: boolean;
}

export default function useBalanceAssetSymbolsByQuoteValueDesc(
	params?: UseBalanceAssetSymbolsByQuoteValueDescParams
) {
	const { isIsolated } = params ?? {};
	const currentAccountKey = useDriftAccountStore((s) => s.currentUserKey);
	const balances = useAccountSpotBalances(currentAccountKey);

	return useMemo(() => {
		if (!currentAccountKey) {
			return;
		}

		// For isolated positions, only show USDC collateral
		if (isIsolated) {
			return ['USDC'];
		}

		return balances
			.sort((a, b) => b.quoteValue.sub(a.quoteValue).toNum())
			.map((bal) => bal.asset.symbol);
	}, [balances, currentAccountKey, isIsolated]);
}
